import React, { useEffect, useState } from 'react';
import Header from '../../components/ui/Header';
import CredentialSummaryWidget from './components/CredentialSummaryWidget';
import RecentCredentialsGrid from './components/RecentCredentialsGrid';
import QuickActionsPanel from './components/QuickActionsPanel';
import VerificationHistorySection from './components/VerificationHistorySection';
import NotificationsPanel from './components/NotificationsPanel';
import KeyMetricsDisplay from './components/KeyMetricsDisplay';
import Icon from '../../components/AppIcon';

const Dashboard = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [userName] = useState('Alex Johnson');
  const [lastLoginTime] = useState(new Date('2025-09-02T08:30:00'));

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, []);

  const formatGreeting = () => {
    const hour = currentTime?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const formatLastLogin = () => {
    const now = new Date();
    const diff = now - lastLoginTime;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    
    if (hours < 1) {
      const minutes = Math.floor(diff / (1000 * 60));
      return `${minutes} minutes ago`;
    } else if (hours < 24) {
      return `${hours} hours ago`;
    } else {
      const days = Math.floor(hours / 24);
      return `${days} days ago`;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-8">
          {/* Welcome Section */}
          <div className="mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h1 className="text-3xl font-bold text-foreground mb-2">
                  {formatGreeting()}, {userName}
                </h1>
                <p className="text-muted-foreground">
                  Welcome to your digital identity command center. Last login: {formatLastLogin()}
                </p>
              </div>
              <div className="mt-4 lg:mt-0 flex items-center space-x-4">
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <Icon name="Clock" size={16} />
                  <span>{currentTime?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-success">
                  <Icon name="Wifi" size={16} />
                  <span>Connected</span>
                </div>
              </div>
            </div>
          </div>

          {/* Main Dashboard Grid */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
            {/* Left Column - Primary Content */}
            <div className="xl:col-span-2 space-y-8">
              {/* Credential Summary Widget */}
              <CredentialSummaryWidget />

              {/* Recent Credentials Grid */}
              <RecentCredentialsGrid />

              {/* Verification History Section */}
              <VerificationHistorySection />
            </div>

            {/* Right Column - Secondary Content */}
            <div className="space-y-8">
              {/* Quick Actions Panel */}
              <QuickActionsPanel />

              {/* Notifications Panel */}
              <NotificationsPanel />
            </div>
          </div>

          {/* Bottom Section - Key Metrics */}
          <div className="mt-8">
            <KeyMetricsDisplay />
          </div>

          {/* Footer Information */}
          <div className="mt-8 pt-8 border-t border-border">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between text-sm text-muted-foreground">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  <Icon name="Shield" size={16} />
                  <span>VerifyChain v2.1.0</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Lock" size={16} />
                  <span>End-to-end encrypted</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Globe" size={16} />
                  <span>Decentralized network</span>
                </div>
              </div>
              <div className="mt-4 lg:mt-0">
                <span>&copy; {new Date()?.getFullYear()} VerifyChain. All rights reserved.</span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;